import React from 'react';
import styled from 'styled-components';
import DragAndDrop from 'shared/components/DragAndDrop';
import ReactDragList from 'react-drag-list';
import { SmallButton } from 'shared/components/Button';
import { hw, scrollbar } from '../homeworkUi';

interface BatchFileInputTableProps {
    setFileList: React.Dispatch<React.SetStateAction<File[]>>,
    fileList: File[],
    accept:string
}

const BatchFileInputTable = ({accept, fileList, setFileList }: BatchFileInputTableProps) => {

    const handleChange = (file: File[]) => {
        setFileList(prev => [...prev, ...file]);
    };

    const handleUpdate = (event: any, newFileList: any[]) => {
        const updatedList: File[] = newFileList.map((item: any) => {
            return fileList.find(file => file.name === item.name) || item;
        });
        setFileList(updatedList);
    };

    const handleDelete = (index: number) => {
        setFileList(prev => prev.filter((item, idx) => idx !== index));
    }

    const dragList = (record: any, index: number) => (
        <Item key={index}>
            <Index>{index + 1}</Index>
            <FileName title={record.name}>{record.name}</FileName>
            <SmallButton name='삭제' onButtonClick={() => handleDelete(index)} />
        </Item>
    );

    return (
        <InputWrap>
            <DragAndDrop accept={accept} handleChange={handleChange} />
            <ItemWrap>
                {fileList.length === 0 ? (
                    <EmptyHint>파일을 끌어다 놓거나 클릭해서 추가하세요</EmptyHint>
                ) : (
                    <ReactDragList
                        dataSource={fileList}
                        rowKey="name"
                        row={dragList}
                        handles={false}
                        className="simple-drag"
                        rowClassName="simple-drag-row"
                        onUpdate={handleUpdate}
                    />
                )}
            </ItemWrap>
        </InputWrap>
    );
};

const InputWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    border: 1px solid ${hw.border};
    border-radius: 12px;
    overflow: hidden;
    background: ${hw.surface};
`;

const ItemWrap = styled.div`
    height: 200px;
    overflow-y: auto;
    ${scrollbar}
`;

const Item = styled.div`
    display: flex;
    padding: 8px 10px;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    border-bottom: 1px solid ${hw.border};
    background-color: white;

    &:hover {
        background: ${hw.brandSoft};
    }
`;

const Index = styled.span`
    font-size: 11px;
    font-weight: 700;
    color: ${hw.textSubtle};
    width: 18px;
    flex-shrink: 0;
`;

const FileName = styled.div`
    font-size: 12px;
    color: ${hw.text};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const EmptyHint = styled.div`
    padding: 28px 12px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 12px;
`;

export default BatchFileInputTable;
